import { useMutation } from "react-query";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

interface IframelyOembed {
  embed_type: "rich" | "video";
  html: string;
  id: number;
  sgid: string;
  type: "embed";
  url: string;
}

interface CreateOembedResponse {
  oembed: IframelyOembed;
}
export const useCreateEmbed = () =>
  useMutation<CreateOembedResponse, Error, string>({
    mutationFn: url =>
      reactQueryPost(
        internalApi.richTextFields.createOembed({ params: { url } }),
      ),
  });
